import axios from 'axios';

import { IPruvodceVH } from './pruvodceVH';
import { IPruvodceVYPIS } from './pruvodceVYPIS';

export const zhrnutiVHdownload = (id: number, data: IPruvodceVH, type: 'pdf' | 'xml', typpruvodce: 'NEWM' | 'REPL') => {
    return axios({
        method: 'POST',
        url: `SRD/${id}/pruvodceVH/${type.toUpperCase()}`,
        data: {
            ...data,
            typpruvodce: typpruvodce
        }
    });
};

export const zhrnutiVYPISdownload = (id: number, data: IPruvodceVYPIS) => {
    return axios({
        method: 'POST',
        url: `SRD/${id}/pruvodceVYPIS/XML`,
        data: {
            ...data
        }
    });
};
